<template>
  <div>

    <b-form @submit.stop.prevent="formOnsubmit">

      <!-- Name input -->
      <b-form-group
        id="input-group-name"
        label="Nama:"
        label-for="input-name"
      >
        <b-form-input
          id="input-name"
          v-model="form.name"
          placeholder="Nama Diagnosa"
        ></b-form-input>
        <small class="text-danger">{{ error.name }}</small>
      </b-form-group>

      <!-- Code input -->
      <b-form-group
        id="input-group-code"
        label="Kode:"
        label-for="input-code"
      >
        <b-form-input
          id="input-code"
          v-model="form.code"
          placeholder="Kode Diagnosa"
        ></b-form-input>
        <small class="text-danger">{{ error.code }}</small>
      </b-form-group>

      <!-- Description input -->
      <b-form-group id="input-group-description">
        <label for="input-description">Deskripsi: <em class="text-muted">opsional</em></label>
        <b-form-textarea
          id="input-description"
          v-model="form.description"
          placeholder="Deksripsi Diagnosa"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
        <small class="text-danger">{{ error.description }}</small>
      </b-form-group>

      <!-- Submit & Cancel button -->
      <b-button
        type="submit"
        variant="primary"
      >Simpan</b-button>
      <b-button
        type="button"
        class="ml-2"
        variant="default"
        @click="cancelOnClick"
      >
        Batal
      </b-button>

    </b-form>

  </div>
</template>

<script>

import module from '@/core/modules/CrudModule.js'
import validation from '@/core/modules/ValidationModule.js'

export default {

  props: {
    form: Object,
    route: String,
    purpose: String,
  },

  data() {
    return {
      // Error
      error: {
        name: '',
        code: '',
        description: ''
      }
    }
  },

  methods: {

    cancelOnClick(){
      if(this.purpose != "modal"){
        this.$router.push('/masters/diagnoses')
      }else{
        this.$bvModal.hide("modal-patient-x-diagnose");
      }
    },

    async formOnsubmit() {
      // Make Request
      let response = await module.submit(this.form, this.route)
      // Check Response
      if (response.state == 'error') {
        // Validation Error
        this.error = validation.setValidationError(this.error, response.error.errors)
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, 'success')

        this.$root.$emit('sendDiagnoseToModal',response.success.item);

        if(this.purpose != "modal"){
          this.$router.push('/masters/diagnoses')
        }else{
          this.$bvModal.hide('modal-patient-x-diagnose')
          this.$emit('updateDiagnosaTabelItem')
        }
      }
    }

  }

}
</script>

<style>
</style>